/* eslint-disable */
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/LineChartGraph.style.css";
import PropTypes from "prop-types";

export default function LineChartComponent({ data }) {
  console.log(data.lineChartData);
  // Find the maximum value
  const allValues = data.lineChartData?.flatMap(({ members, staffs }) => [
    members,
    staffs,
  ]);
  const maxValue = Math.max(...allValues);

  // Find the nearest bigger value divisible by 10
  const nearestValue = Math.ceil(maxValue / 10) * 10;

  // Generate an array of reference lines from 10 to nearestValue (100)
  const referenceLines = [];
  for (let i = 10; i <= nearestValue; i += 10) {
    referenceLines.push(
      <ReferenceLine key={i} y={i} stroke="#CFCFCF" strokeWidth={1} />
    );
  }
  return (
    <div className="chart-container">
      {/* <h2 className="chart-title">Members vs Staff Over Time</h2> */}
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data.lineChartData}>
          <XAxis dataKey="name" stroke="#555" />
          <YAxis stroke="#555" />
          <Tooltip />
          <Line
            type="linear"
            dataKey="members"
            stroke="#1E90FF"
            strokeWidth={2}
            name="Members"
            dot={false}
          />
          <Line
            type="linear"
            dataKey="staffs"
            stroke="#A86AEB"
            strokeWidth={2}
            name="Staffs"
            dot={false}
          />
          {referenceLines}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

LineChartComponent.propTypes = {
  data: PropTypes.object.isRequired,
};
